import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config";
import { PlatformLocation } from '@angular/common';
import { StoreService } from '../store.service';
var CasePracticeReportNewComponent = (function () {
    function CasePracticeReportNewComponent(commonService, apiService, route, platformLocation, router, storeService) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.platformLocation = platformLocation;
        this.router = router;
        this.storeService = storeService;
        this.itemClickEnable = false;
        this.isOpenClass = 0;
        this.assetsRoute = "../../assets";
        this.isHarmonyOS = false; //是否鸿蒙系统
    }
    CasePracticeReportNewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isHarmonyOS = this.commonService.isHarmonyOS();
        this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        var that = this;
        this.isShowReportLv = false;
        this.bestPathBoxShow = false;
        this.analysisBoxShow = false;
        this.starShow = false;
        this.pathClickable = true;
        this.goToListClickedStatus = false;
        this.redoClickedStatus = false;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.route.params.subscribe(function (params) {
            _this.practiceId = params["practiceId"];
            _this.exerciseId = params["exerciseId"];
            _this.learningPathId = params["learningPathId"];
            _this.apiService
                .ajax({
                type: "get",
                'url': '/ddilearner/v1/getLearningPathMetaId/' + _this.learningPathId,
            })
                .subscribe(function (result) {
                _this.learningPathMetaId = result.data;
                _this.updateExerciseReports();
            });
            _this.apiService
                .ajax({
                type: "get",
                url: "/sr/learningtour",
            })
                .subscribe(function (result) {
                _this.learningTour = result;
            });
            _this.apiService
                .ajax({
                type: "get",
                url: "/api/exerciseTutor/" + _this.exerciseId,
            })
                .subscribe(function (result) {
                _this.tutor = result.tutor;
                _this.optimum = result.optimum;
            });
        });
    };
    CasePracticeReportNewComponent.prototype.updateExerciseReports = function () {
        var _this = this;
        this.apiService
            .ajax({
            type: "get",
            url: "/sr/insideapi/updateExerciseReports?exerciseId=" + this.exerciseId,
        })
            .subscribe(function () {
            _this.getKasInfo(_this.learningPathMetaId);
        });
    };
    CasePracticeReportNewComponent.prototype.getKasInfo = function (learningPathMetaId) {
        var _this = this;
        var url = (learningPathMetaId == 11 || learningPathMetaId == 403) ?
            "sr/practice/getReports/" + this.exerciseId + "/" + this.practiceId :
            "/api/practices/" + this.exerciseId + "/" + this.practiceId + "/report";
        this.getReport(url).then(function (result) {
            _this.practiceMetaId = result.practiceMetaId;
            if (result.reports.length == 0) {
                _this.redo();
            }
            else {
                _this.report = result.reports[0].kas;
                _this.reportName = result.reports[0].name;
                _this.finished = result.allExerciseFinished;
                _this.getLevelInfo(result.reports[0]);
            }
        }).catch(function (error) {
            _this.apiService.ajax({
                'type': 'GET',
                'url': "sr/exercises/autoReset/" + _this.exerciseId
            }).subscribe(function () {
                _this.router.navigate(["learning-path", localStorage.getItem('learningPathMetaId')]);
            });
        });
        // if(learningPathMetaId == 11 || learningPathMetaId == 403){
        //   this.apiService.ajax({
        //     type: "get",
        //     url: "sr/practice/getReports/" + this.exerciseId + "/" + this.practiceId,
        //   }).subscribe(result=>{
        //     this.practiceMetaId = result.practiceMetaId;
        //     if (result.reports.length == 0) {
        //       this.redo();
        //       // this.goToList();
        //     } else {
        //       // this.report = result.reports.kas;
        //       // this.reportName = result.reports.name;
        //       // this.finished = result.allExerciseFinished;
        //       // this.getLevelInfo(result.reports);
        //       this.report = result.reports[0].kas;
        //       this.reportName = result.reports[0].name;
        //       this.finished = result.allExerciseFinished;
        //       this.getLevelInfo(result.reports[0]);
        //     }
        //   })
        // }else{
        //   this.apiService.ajax({
        //       type: "get",
        //       url: "/api/practices/" + this.exerciseId + "/" + this.practiceId + "/report",
        //     }).subscribe((result) => {
        //       console.log(111111111111111111);
        //       console.log(result,111111111);
        //     //无报告数据转向列表页
        //     this.practiceMetaId = result.practiceMetaId;
        //     if (result.reports.length == 0) {
        //       this.redo();
        //       // this.goToList();
        //     } else {
        //       this.report = result.reports[0].kas;
        //       this.reportName = result.reports[0].name;
        //       this.finished = result.allExerciseFinished;
        //       this.getLevelInfo(result.reports[0]);
        //     }
        //   });
        // }
    };
    CasePracticeReportNewComponent.prototype.getLevelInfo = function (reports) {
        var _this = this;
        var that = this;
        $.ajax({
            url: "/sr/insideapi/getlevel",
            type: "post",
            dataType: "json",
            contentType: "application/json;charset=utf-8",
            data: JSON.stringify(this.getKaList(reports)),
            async: false,
            headers: {
                'transtalen-token': localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
                'transtalenuserid': localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
            },
            success: function (result) {
                if (result && result != "") {
                    that.reportKAData = result;
                    that.targetShow = 1;
                }
                else {
                    that.targetShow = 0;
                }
            },
            error: function (er) {
                if (er.status === 401 && Number(er.responseJSON.code) === 106) {
                    that.storeService.notification.notAuthed.next(true);
                }
                that.targetShow = 0;
            },
        });
        if (reports.name == "组织与计划") {
            this.mode = 2;
            if (that.targetShow == 0) {
                this.lvCls = this.mode + "";
            }
            else {
                this.lvCls = this.mode + " bgBlur";
            }
            this.starPicUrl = "/casepracticepando/star2.png";
        }
        else if (reports.name == "影响力") {
            this.mode = 3;
            if (that.targetShow == 0) {
                this.lvCls = this.mode + "";
            }
            else {
                this.lvCls = this.mode + " bgBlur";
            }
            this.starPicUrl = "/casepracticeteam/star_report.png";
        }
        else {
            this.mode = 1;
            if (that.targetShow == 0) {
                this.lvCls = this.mode + "";
            }
            else {
                this.lvCls = this.mode + " bgBlur";
            }
            this.starPicUrl = "/casepracticeteam/star_report.png";
        }
        if (that.targetShow === 0) {
            this.isShowReportLv = false;
        }
        else {
            this.isShowReportLv = true;
        }
        setTimeout(function () {
            _this.itemClickEnable = true;
        }, 500);
    };
    CasePracticeReportNewComponent.prototype.ngAfterViewInit = function () {
        var that = this;
        this.commonService.initPage({
            backgroundColor: "white",
        });
        $(document).ready(function () {
            var listenerTimeout = setInterval(function () {
                var bestPathEle = document.getElementById("bestPathBox"), analysisEle = document.getElementById("analysisContent"), tutorEle = document.getElementById("tourReviewBox");
                if (bestPathEle !== null && analysisEle !== null && tutorEle != null) {
                    bestPathEle.addEventListener("scroll", that.onBestPathScroll);
                    analysisEle.addEventListener("scroll", that.onAnalysisScroll);
                    tutorEle.addEventListener("scroll", that.onTutorScroll);
                    clearInterval(listenerTimeout);
                }
            }, 500);
        });
    };
    /*
      格式化KA对象方法
       report：传递一个报告对象
     */
    CasePracticeReportNewComponent.prototype.getKaList = function (report) {
        var kaJson = {
            id: report.id,
            name: report.name,
            type: report.type,
            kas: {},
            exercisesId: this.exerciseId,
            questionId: null,
            optionId: null,
        };
        if (window["exercises" + this.exerciseId] != null) {
            var exerciseConfig = window["exercises" + this.exerciseId];
            kaJson.questionId = exerciseConfig.questionId;
            kaJson.optionId = exerciseConfig.optionId;
        }
        if (report && Array.isArray(report.kas)) {
            for (var i = 0; i < report.kas.length; i++) {
                var kaItem = report.kas[i];
                if (kaItem) {
                    //kaJson.kas.push({name:kaItem.name,value:Number(kaItem.value)});
                    kaJson.kas[kaItem.name] = kaItem.value;
                }
            }
        }
        else {
            kaJson = null;
            this.close();
        }
        return kaJson;
    };
    CasePracticeReportNewComponent.prototype.close = function () {
        var _this = this;
        this.apiService
            .ajax({
            type: "get",
            url: "/api/learningpathes/" + this.learningPathId,
        })
            .subscribe(function (result) {
            //转向情景列表
            var link = _this.abilityConfig.getPracticeLinkList(result.name, _this.learningPathId, _this.practiceMetaId);
            if (localStorage.getItem('openClass')) {
                var href_1 = '';
                link.forEach(function (v) {
                    href_1 += '/' + v;
                });
                href_1 = href_1 + '#isShowBack=0';
                _this.platformLocation['location']['href'] = _this.platformLocation['location']['origin'] + href_1;
            }
            else {
                if (link.length > 0) {
                    if (_this.type) {
                        _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        _this.router.navigate(link);
                    }
                }
            }
        });
    };
    CasePracticeReportNewComponent.prototype.onBestPathScroll = function () {
        var overlay = document.getElementById("bestPathBox");
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
            1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeReportNewComponent.prototype.onAnalysisScroll = function () {
        var overlay = document.getElementById("analysisContent");
        console.log("scroll1");
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
            1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeReportNewComponent.prototype.onTutorScroll = function () {
        var overlay = document.getElementById("tourReviewBox");
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
            1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeReportNewComponent.prototype.subWrapOneOut = function () {
        $("#subWrapOne").fadeOut(function () {
            $("#subWrapTwo").fadeIn();
            $("#btnWrap").fadeIn();
        });
    };
    CasePracticeReportNewComponent.prototype.tourReviewBoxIn = function () {
        $("#tourReviewShade").fadeIn();
        $("#tourReviewBox").fadeIn();
        $("#closeBtn1").fadeIn();
        this.pathClickable = false;
    };
    CasePracticeReportNewComponent.prototype.tourReviewBoxOut = function () {
        $("#tourReviewShade").fadeOut();
        $("#tourReviewBox").fadeOut();
        $("#closeBtn1").fadeOut();
        this.pathClickable = true;
    };
    CasePracticeReportNewComponent.prototype.bestPathIn = function () {
        if (!this.pathClickable) {
            return;
        }
        $("#closeBtn2").fadeIn();
        this.bestPathBoxShow = true;
        $("#shade").fadeIn();
    };
    CasePracticeReportNewComponent.prototype.bestPathOut = function () {
        $("#closeBtn2").fadeOut();
        this.bestPathBoxShow = false;
        $("#shade").fadeOut();
    };
    CasePracticeReportNewComponent.prototype.redo = function () {
        var _this = this;
        var influenceProExerciseMetaId = Number(localStorage.getItem('influenceProExerciseMetaId'));
        if (!this.pathClickable || this.redoClickedStatus) {
            return;
        }
        else {
            this.redoClickedStatus = true;
        }
        if (this.learningPathMetaId == 13) {
            this.apiService
                .ajax({
                type: "post",
                url: "/api/pnoReset/" + this.exerciseId,
            })
                .subscribe(function (result) {
                var practiceId = result.practiceId;
                var learningPathId = result.learningPathId;
                var practiceMetaId = result.practiceMetaId;
                var link = [
                    learningPathId,
                    practiceMetaId,
                    "case-practice-p-and-o",
                    _this.exerciseId,
                ];
                if (_this.type) {
                    _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                }
                else {
                    _this.router.navigate(link);
                }
                var exerciseMetaId = $('#exerciseMetaId').val();
                _this.apiService.learingTime({ learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: "情景模拟", courseUnit: '', type: 1, btnName: exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(function (result) {
                    console.log(result);
                });
                console.log(exerciseMetaId);
                _this.commonService.sendPostMessage(0, 'isPractice' + 'Complete');
            });
        }
        else {
            this.apiService.resetExercise(this.exerciseId).subscribe(function (result) {
                _this.apiService.saveProgress({ exerciseId: _this.exerciseId, progress: 0 }).subscribe();
                var practiceId = result.practiceId;
                var learningPathId = result.learningPathId;
                var practiceMetaId = result.practiceMetaId;
                if (_this.learningPathMetaId == 11 || _this.learningPathMetaId == 403) {
                    var link = [
                        _this.learningPathId,
                        practiceMetaId,
                        "case-practice-authorization",
                        _this.exerciseId,
                    ];
                    if (_this.type) {
                        _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        _this.router.navigate(link);
                    }
                    var exerciseMetaId = $('#exerciseMetaId').val();
                    _this.apiService.learingTime({ learningPathMetaId: $('#learningPathMetaIdContainer').val(), module: "情景模拟", courseUnit: '', type: 1, btnName: exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(function (result) {
                        console.log(result);
                    });
                    console.log(exerciseMetaId);
                    _this.commonService.sendPostMessage(0, 'isPractice' + 'Complete');
                }
                else if (_this.learningPathMetaId == 14) {
                    var link = [
                        _this.learningPathId,
                        practiceMetaId,
                        "case-practice-cooperation",
                        _this.exerciseId,
                    ];
                    if (_this.type) {
                        _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        _this.router.navigate(link);
                    }
                    var exerciseMetaId = $('#exerciseMetaId').val();
                    _this.apiService.learingTime({ learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: "情景模拟", courseUnit: '', type: 1, btnName: exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(function (result) {
                        console.log(result);
                    });
                    console.log(exerciseMetaId);
                    _this.commonService.sendPostMessage(0, 'isPractice' + 'Complete');
                }
                else if (_this.learningPathMetaId == 15) {
                    var link = [
                        _this.learningPathId,
                        practiceMetaId,
                        "case-practice-influence",
                        _this.exerciseId,
                    ];
                    if (_this.type) {
                        _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        _this.router.navigate(link);
                    }
                    var exerciseMetaId = $('#exerciseMetaId').val();
                    _this.apiService.learingTime({ learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: "情景模拟", courseUnit: '', type: 1, btnName: exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(function (result) {
                        console.log(result);
                    });
                    console.log(exerciseMetaId);
                    _this.commonService.sendPostMessage(0, 'isPractice' + 'Complete');
                }
                else if ((_this.learningPathMetaId == 607 || _this.learningPathMetaId == 30) && (influenceProExerciseMetaId == 60701 || influenceProExerciseMetaId == 131)) {
                    var link = [
                        _this.learningPathId,
                        practiceMetaId,
                        "case-practice-influence-pro",
                        _this.exerciseId,
                    ];
                    if (_this.type) {
                        _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        _this.router.navigate(link);
                    }
                    var exerciseMetaId = $('#exerciseMetaId').val();
                    _this.apiService.learingTime({ learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: "情景模拟", courseUnit: '', type: 1, btnName: exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(function (result) {
                        console.log(result);
                    });
                    console.log(exerciseMetaId);
                    _this.commonService.sendPostMessage(0, 'isPractice' + 'Complete');
                }
                else if ((_this.learningPathMetaId == 607 || _this.learningPathMetaId == 30) && (influenceProExerciseMetaId == 60702 || influenceProExerciseMetaId == 141)) {
                    _this.apiService.ajax({
                        type: "get",
                        url: "/sr/insideapi/deleteExerciseChoiceUser?exerciseId=" +
                            _this.exerciseId,
                    }).subscribe(function (result) {
                        var link = ['case-practice-influence-supplier', _this.learningPathId, _this.practiceId, _this.exerciseId, 141];
                        if (_this.practiceMetaId === 607) {
                            link = ['case-practice-influence-supplier', _this.learningPathId, _this.practiceId, _this.exerciseId, 60702];
                        }
                        if (_this.type) {
                            _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                        }
                        else {
                            _this.router.navigate(link);
                        }
                    });
                }
                else if ((_this.learningPathMetaId == 607 || _this.learningPathMetaId == 30) && (influenceProExerciseMetaId == 60703 || influenceProExerciseMetaId == 151)) {
                    _this.apiService.ajax({
                        type: "get",
                        url: "/sr/insideapi/deleteExerciseChoiceUser?exerciseId=" +
                            _this.exerciseId,
                    }).subscribe(function (result) {
                        var link = ['case-practice-influence-supplier', _this.learningPathId, _this.practiceId, _this.exerciseId, 151];
                        if (_this.practiceMetaId === 607) {
                            link = ['case-practice-influence-supplier', _this.learningPathId, _this.practiceId, _this.exerciseId, 60703];
                        }
                        if (_this.type) {
                            _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                        }
                        else {
                            _this.router.navigate(link);
                        }
                    });
                }
                else {
                    var link = [
                        learningPathId,
                        practiceMetaId,
                        "case-practice",
                        _this.exerciseId,
                    ];
                    if (_this.type) {
                        _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        _this.router.navigate(link);
                    }
                }
            });
        }
    };
    CasePracticeReportNewComponent.prototype.analysisBoxIn = function (i) {
        if (!this.itemClickEnable) {
            return false;
        }
        var _this = this;
        this.currentName = this.report[i].name;
        this.currentDescription = this.report[i].description;
        this.currentTotal = this.report[i].value;
        this.currentAnalysis = this.report[i].analysis;
        $("#analysisShade").fadeIn();
        // 滚动到订端
        $("#analysisContent").scrollTop(0);
        // $('#analysisBox').fadeIn();
        this.analysisBoxShow = true;
        $("body").css("overflow-y", "hidden");
        setTimeout(function () {
            _this.starShow = true;
        }, 300);
        this.pathClickable = false;
        document.getElementById("analysisShade").ontouchmove = function (e) {
            e.preventDefault();
        };
        document.getElementById("analysisHead").ontouchmove = function (e) {
            e.preventDefault();
        };
        document.getElementById("closeBtn3").ontouchmove = function (e) {
            e.preventDefault();
        };
    };
    CasePracticeReportNewComponent.prototype.analysisBoxOut = function () {
        $("#analysisShade").fadeOut();
        this.analysisBoxShow = false;
        $("body").css("overflow-y", "scroll");
        this.starShow = false;
        this.pathClickable = true;
    };
    CasePracticeReportNewComponent.prototype.goToList = function () {
        var _this = this;
        if (this.goToListClickedStatus) {
            return;
        }
        else {
            this.goToListClickedStatus = true;
        }
        this.apiService
            .ajax({
            type: "get",
            url: "/api/learningpathes/" + this.learningPathId,
        })
            .subscribe(function (result) {
            //转向情景列表
            var link = _this.abilityConfig.getPracticeLinkList(result.name, _this.learningPathId, _this.practiceMetaId);
            if (localStorage.getItem('openClass')) {
                console.log(_this.platformLocation);
                var href_2 = '';
                link.forEach(function (v) {
                    href_2 += '/' + v;
                });
                href_2 = href_2 + '#isShowBack=0';
                _this.platformLocation['location']['href'] = _this.platformLocation['location']['origin'] + href_2;
            }
            else {
                if (link.length > 0) {
                    if (_this.type) {
                        _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        _this.router.navigate(link);
                    }
                }
            }
        });
    };
    CasePracticeReportNewComponent.prototype.linkToPostSurvey = function () {
        var _this = this;
        this.apiService
            .getOrCreateLearningPath(this.learningPathMetaId)
            .subscribe(function (result) {
            _this.learningPath = result;
            var link = [
                "survey",
                _this.learningPath.id,
                _this.learningPath.subItems[4].surveyMetaId,
                1,
            ];
            _this.router.navigate(link);
        });
    };
    CasePracticeReportNewComponent.prototype.getReport = function (url) {
        return this.apiService.ajax({
            type: "get",
            url: url,
        }).toPromise();
    };
    return CasePracticeReportNewComponent;
}());
export { CasePracticeReportNewComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-report-new/case-practice-report-new.component.ts.pre-build-optimizer.js